// extracted by mini-css-extract-plugin
export default {"main":"Book_main__XxsOR","separator":"Book_separator__DVJSC","abstract":"Book_abstract__pNPPB"};